// src/store/questionnaireSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
  level1Data: [],
  level2Data: [],
  level3Data: [],
  level4Data: [],
  level5Data: [],
  level6Data: {},
  level7Data: {},
  currentStep: 1,
  loading: false,
  error: null,
  questions: []
};

const questionnaireSlice = createSlice({
  name: 'questionnaire',
  initialState,
  reducers: {
    setQuestions: (state, action) => {
      state.questions = action.payload;
    },
    updateLevel1: (state, action) => {
      state.level1Data = action.payload;
    },
    updateLevel2: (state, action) => {
      state.level2Data = action.payload;
    },
    updateLevel3: (state, action) => {
      state.level3Data = action.payload;
    },
    updateLevel4: (state, action) => {
      state.level4Data = action.payload;
    },
    updateLevel5: (state, action) => {
      state.level5Data = action.payload;
    },
    updateLevel6: (state, action) => {
      state.level6Data = action.payload;
    },
    updateLevel7: (state, action) => {
      state.level7Data = action.payload;
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    resetQuestionnaire: () => initialState
  }
});

export const {
  setQuestions,
  updateLevel1,
  updateLevel2,
  updateLevel3,
  updateLevel4,
  updateLevel5,
  updateLevel6,
  updateLevel7,
  setCurrentStep,
  resetQuestionnaire
} = questionnaireSlice.actions;

export default questionnaireSlice.reducer;